export enum AttendanceStatus {
    PRESENT="PRESENT", ABSENT="ABSENT", LEAVE="LEAVE", UNMARKED_ATTENDANCE="UNMARKED_ATTENDANCE"
}
